export default __webpack_public_path__ + "static/media/c4.c84fd836.png";